import React, { useState, useEffect } from "react";
import Content from "components/Content";
import {
  Grid,
  Box,
  Typography,
  useTheme,
  Pagination,
  PaginationItem,
  Divider,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { tokens } from "../../theme";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DataGrid from "./DataGrid";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";

function EntranceTableComponent(props) {
  const { claims, setClaimSelected, setShowTypeAssignClaim, setShowMessageConfirmReAssign, account, currentPage, setCurrentPage, cantElement, setCantElement } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);

  const CircularItem = ({ status = "none" }) => {
    const statusColors = {
      verde: "green",
      rojo: "red",
      amarillo: "yellow",
      hv_verde: "green",
      hv_rojo: "red",
      hv_amarillo: "yellow",
      ive: "#B31EA4",
    };
    const color = statusColors[status]

    return (
      <>
        {!status.includes("hv_") ? (
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              backgroundColor: color,
              margin: "10px auto"
            }}
          />
        ) : (
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              backgroundColor: "black",
              border: "2px solid #1DBDCD",
              margin: "10px auto",
            }}
          >
            {/* Triángulo */}
            <Box
              sx={{
                width: 0,
                height: 0,
                borderLeft: "7px solid transparent",
                borderRight: "7px solid transparent",
                borderBottom: `14px solid ${color}`,
                marginLeft: "27%",
                marginTop: "23%"
              }}
            />
          </Box>
        )}
      </>
    );
  };
  const columns = [
    {
      field: "type_of_claim",
      headerName: "",
      flex: 1,
      headerAlign: "center",
      maxWidth: 100,
      style: "background-color:#B1B1B1",
      align: "center",
      renderCell: (params) => (
        <CircularItem status={params.value} />
      ),
    },
    {
      field: "id",
      headerName: "RECLAMO",
      flex: 1,
      headerAlign: "center",
      align: "center",
      maxWidth: 150,
      renderCell: (params) => (
        <div className="swt-table-field-name">{params.value}</div>
      ),
    },
    {
      field: "assigned",
      headerName: "ASIGNADO",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ textTransform: 'uppercase' }}>{params.value}</span>
      ),
    },
    {
      field: "status",
      headerName: "ESTADO",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span style={{ textTransform: 'uppercase' }}>{params.value === 'Active' ? 'Activo' : 'Inactivo'}</span>
      ),
    },
    {
      field: "ticket_status",
      headerName: "TICKETS CON ACTIVIDAD",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];
  const themeTable = createTheme({
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            backgroundColor: "#D9D9D9",
            borderColor: "#D9D9D9",
            "& .MuiDataGrid-main": {
              backgroundColor: "#D9D9D9",
              borderColor: "#D9D9D9",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#B1B1B1",
              fontFamily: "Encode Sans",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              textAlign: "center",
            },
            "& .MuiDataGrid-toolbarContainer .MuiInput-root": {
              backgroundColor: "#D9D9D9",
              color: "#000",
            },
            "& .MuiDataGrid-gutters": {
              color: "#000",
            },
            "& .Mui-selected": {
              backgroundColor: "#56D2FF !important",
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "transparent",
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            color: "#000",
            "& svg": {
              color: "#000",
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    if (claims) {
      const formattedClaims = claims.map((claim) => {
        const status = claim.ticket_status;
        
        // Verificamos si hay novedades en el ticket (el backend nos manda este booleano)
        const hasNewInfo = claim.ticket_activity_status;

        // colores según el estado
        let bgColor = "transparent";
        let textColor = "inherit";

        if (status === "Pendiente Revisión") {
          bgColor = "#FFC107";
          textColor = "#5d4037";
        } else if (status === "En curso") {
          bgColor = "#4CAF50";
          textColor = "#ffffff";
        } else if (status === "Cerrado") {
          bgColor = "#2196F3";
          textColor = "#ffffff";
        }

        return {
          ...claim,
          // Estado del ticket
          ticket_status: status && status !== "Sin ticket" ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "12px",
                  backgroundColor: bgColor,
                  color: textColor,
                  fontSize: "12px",
                  fontWeight: "bold",
                  textAlign: "center",
                  boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
                }}
              >
                {status}

                {hasNewInfo === true && (
                  <Box
                    sx={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#E30000",
                      border: "1px solid #ffffff",
                      flexShrink: 0,
                      animation: "pulse 1.5s ease-in-out infinite",
                      "@keyframes pulse": {
                        "0%": {
                          opacity: 1,
                          boxShadow: "0 0 0 0 rgba(227, 0, 0, 0.4)",
                        },
                        "70%": {
                          opacity: 0.7,
                          boxShadow: "0 0 0 4px rgba(227, 0, 0, 0)",
                        },
                        "100%": {
                          opacity: 1,
                          boxShadow: "0 0 0 0 rgba(227, 0, 0, 0)",
                        },
                      },
                    }}
                  />
                )}
              </Box>
            </Box>
          ) : (
            <Typography sx={{ textAlign: "center", color: "#ccc", fontSize: "14px", width: "100%" }}>
              Sin Tickets
            </Typography>
          )
        };
      });

      setRows(formattedClaims);
      setOriginalRows(formattedClaims);
    }
  }, [claims, currentPage]);

  const [search, setSearch] = useState("");

  const handleFilter = (e) => {
    const text = e.target.value.toLowerCase();
    setSearch(text);
    setCurrentPage(1);

    if (text.trim() === "") {
      setRows(originalRows);
    } else {
      const filtered = originalRows.filter((row) => {
        return Object.entries(row).some(([key, value]) => {
          // Evitamos buscar dentro de objetos o valores nulos
          if (value === null || value === undefined || typeof value === "object") {
            return false;
          }
          return String(value).toLowerCase().includes(text);
        });
      });
      setRows(filtered);
    }
  };

  /* const handleFilter = (e) => {
    const text = e.target.value.toLowerCase();
    setSearch(text);
    setCurrentPage(1);

    if (text.trim() === "") {
      setRows(originalRows);
    } else {
      const filtered = originalRows.filter((row) => {
        return Object.values(row).some((value) =>
          String(value).toLowerCase().includes(text)
        );
      });
      setRows(filtered);
    }
  }; */

  return (
    <Content className="swt-dashboard" isLoaded="true">
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          mx: "150px",
          my: 3,
          mb: 0,
        }}
      >
        <TextField
          placeholder="Buscar..."
          InputProps={{
            endAdornment: (
              <SearchIcon
                sx={{
                  fill: "#A2A2BD",
                  marginRight: "8px",
                }}
              />
            ),
          }}
          sx={{
            m: 0,
            p: 0,
            backgroundColor: "#FFF",
            borderRadius: "15px",
            border: "1px solid rgba(61, 62, 64, 0.50)",
            background: "#fff",
            "& fieldset": {
              borderRadius: "5px",
            },
            "& input": {
              paddingY: "12px",
              fontFamily: "Encode Sans",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "unset !important",
            },
            width: "100%",
            maxWidth: "600px",
          }}
          onChange={handleFilter}
        />
      </Box>
      <Box sx={{ margin: "20px 50px 50px 50px" }}>
        <ThemeProvider theme={themeTable}>
          <DataGrid
            rows={rows}
            columns={columns}
            sx={{ minHeight: "600px" }}
            backgroundColor={"#fff"}
            noDataMessage="No hay reclamos para mostrar en este momento."
            initialState={{
              pagination: {
                paginationModel: {
                  page: currentPage - 1,
                  pageSize: 10,
                },
              },
            }}
            disableColumnMenu
            pageSizeOptions={[10, 15, 30]}
            setClaimSelected={setClaimSelected}
            setShowTypeAssignClaim={setShowTypeAssignClaim}
            setShowMessageConfirmReAssign={setShowMessageConfirmReAssign}
            account={account}
            cantElement={cantElement}
            setCantElement={setCantElement}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </ThemeProvider>
      </Box>
    </Content>
  );
}

export default EntranceTableComponent;
